
(function() {
  

  async function getCart() {
    const res = await fetch(`/cart.js?ts=${Date.now()}`, { credentials: 'same-origin' });
    return res.json();
  }

  async function removeByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function getIdsFromDOM() {
    const container = document.querySelector('.package-protection');
    if (!container) return null;
    return {
      productId: parseInt(container.dataset.shipProductId, 10),
      variantId: parseInt(container.dataset.shipVariantId, 10),
      checkbox: container.querySelector('.shippingProtectionToggle')
    };
  }

  function findProtection(cart, productId, variantId) {
    // Prefer variant match (more precise), fallback to product match
    return cart.items.find(i => (variantId && i.variant_id === variantId) || i.product_id === productId);
  }

  let ensureLock = false;
  async function ensureProtectionNotAlone() {
    if (ensureLock) return;
    const ids = getIdsFromDOM();
    if (!ids) return;

    ensureLock = true;
    try {
      const cart = await getCart();
      const protection = findProtection(cart, ids.productId, ids.variantId);
      if (!protection) { ensureLock = false; return; }

      const nonProtectionCount = cart.items.filter(i =>
        !((ids.variantId && i.variant_id === ids.variantId) || i.product_id === ids.productId)
      ).length;

      if (nonProtectionCount === 0) {
        await removeByKey(protection.key);
        // Best-effort UI sync
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // If there’s a checkbox, reflect state
        if (ids.checkbox) ids.checkbox.checked = false;
      }
    } catch (err) {
      console.warn('ensureProtectionNotAlone failed:', err);
    } finally {
      ensureLock = false;
    }
  }



  async function handleProtectionChange(e) {
    const checkbox = e.target;
    const container = checkbox.closest('.package-protection');
    if (!container) return;

    const productId = parseInt(container.dataset.shipProductId, 10);
    const variantId = parseInt(container.dataset.shipVariantId, 10);
    const isChecked = checkbox.checked;

    try {
      if (isChecked) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

         setTimeout(fetchLocationInfo2, 1000);

      } else {
        const cart = await getCart();
        const lineItem = findProtection(cart, productId, variantId);
        if (lineItem) await removeByKey(lineItem.key);

        setTimeout(fetchLocationInfo2, 500);
      }

      await ensureProtectionNotAlone();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('Shipping protection toggle failed:', err);
      checkbox.checked = !isChecked;
    }
  }


  const _origFetch = window.fetch;
  window.fetch = async function(input, init) {
    const res = await _origFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
        // Run after the cart endpoint finishes
        Promise.resolve().then(() => ensureProtectionNotAlone());
      }
    } catch (e) {
      // noop
    }
    return res;
  };

 

  let lastCheck = 0;
  setInterval(() => {
    const now = Date.now();
    if (now - lastCheck < 1500) return;
    lastCheck = now;
    ensureProtectionNotAlone();
  }, 2000);


  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('shippingProtectionToggle')) {
      handleProtectionChange(e);
    }
  });

  // Initial pass on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureProtectionNotAlone);
  } else {
    ensureProtectionNotAlone();
  }

})();